import { useWidget } from '@telescope/cassini-hooks';
import { isAfter } from 'date-fns';
import { Open } from 'generated-types/widget';
import { useEffect, useMemo, useRef } from 'react';

export const useNextVoteWindow = (onNextWindow: () => void) => {
  const {
    dataUpdatedAt,
    data: { timezone },
  } = useWidget<Open>({ select: (data) => data.widget.settings.vote_settings.ruleset_parameters });

  const campaignDateTime = new Date().toLocaleString('en-US', { timeZone: timezone });
  const currentDateTime = useMemo(() => new Date(campaignDateTime), [campaignDateTime]);
  const nextWindowDateTime = startOfTomorrow(currentDateTime);
  const nextWindowRef = useRef(nextWindowDateTime);

  // every time the dataUpdatedAt changes, update the currentWindow if it's past midnight
  useEffect(() => {
    if (isAfter(currentDateTime, nextWindowRef.current)) {
      nextWindowRef.current = startOfTomorrow(currentDateTime);
      onNextWindow();
    }
  }, [currentDateTime, onNextWindow, dataUpdatedAt]);

  return {
    timeUntilNextWindow: nextWindowRef.current.getTime() - currentDateTime.getTime(),
  };
};

// return the start of tomorrow given the current date
const startOfTomorrow = (currentDateTime: Date) => {
  const tomorrow = new Date(currentDateTime);
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  return tomorrow;
};
